import { FormModal } from "../../data-entry/FormModal";
import { TrackedItem } from "../../types";

export function EditTrackedItem(props: {
	title: string,

	arr: TrackedItem[],
	initialValues: TrackedItem,
	
	form: string,
	formOptions?: any,

	canHaveOnlyOneActive?: boolean,

	onCancel: () => void,
	onClose: () => void,
}) {

	const obj = {
		...props.initialValues,
		effective: undefined,
		// ceased: undefined,
	}

	return (
		<FormModal
			form={props.form}
			title={props.title}

			obj={obj}

			options={props.formOptions}

			onCancel={props.onCancel}
			onSave={(value: any) => {
				// add new item to the arr
				props.arr.push(value);

				// sort all items by date effective
				props.arr.sort((a, b) => {
					return a.effective.localeCompare(b.effective);
				});

				// if this is the only allowed active one then 
				// everything except the most recent should be ceased
				debugger;
				if (props.canHaveOnlyOneActive) {
					for(let i=0;i<props.arr.length-1;i++) {
						const a = props.arr[i];
						if (!a.ceased) a.ceased = props.arr[i+1].effective;
					}
					const last = props.arr[props.arr.length-1];
					if (last.ceased) last.ceased = "";
				}

				props.onClose();
			}}
		/>
	);
}
